(function(runtime) {
    var _ = runtime.components.dependencies._;
    var Modernizr = runtime.components.dependencies.Modernizr;
    var $ = runtime.components.dependencies.jQuery.v1_11;

    var canTouchThis = !!Modernizr.touch;

    var hammerPaths = {
        component: runtime.paths.join('/Global/UxPlugins/ixp-flow/js/', (runtime.flags.debug ? '/hammer-2.0.4.js' : '/hammer-2.0.4.min.js')),
        cdn: runtime.paths.getCdnPath('/libs/hammer.js/2.0.4/hammer.min.js')
    };

    runtime.dependencies.define('hammer', {
        url: hammerPaths.cdn,

        getInstanceExport: function() {
            return window.Hammer;
        },
        getInstanceVersion: function(instance) {
            return Hammer.VERSION;
        }
    });

    var hammerTime = function(callback) {
        runtime.dependencies.require('hammer')
            .then(function(Hammer) {
                callback(Hammer);
            });
    };


    var constants = runtime.components.constants.merge({
        flowSelector: '.ixp-component-flow[' + runtime.components.constants.components.data.componentRoot + ']',
        initClass: 'ixp-component-flow-init',

        modes: {
            modeAttr: 'data-ixp-flow-mode',
            normalMode: 'normal',
            editMode: 'edit'
        },

        steps: {
            previousStep: 'ixp-component-flow-prev',
            activeStepOut: 'ixp-component-flow-out ixp-flow-prev',
            activeStepIn: 'ixp-component-flow-in ixp-flow-active',
            activeStep: 'ixp-component-flow-active',
            attrPlacement: 'data-ixp-flow-step-placement',
            attrTransitioning: 'data-ixp-flow-step-transitioning'
        },

        progress: {
            wrapperSelector: '.ixp-component-flow-progress',
            doneStep: 'ixp-component-flow-progress-done',
            activeStep: 'ixp-component-flow-progress-active',
            clickable: 'ixp-component-flow-progress-clickable',
            progressInit: 'ixp-component-flow-progress-init'
        },

        templates: {
            badgeUi: '<div class="pe-element-badge-pager"><span data-ixp-flow-action="prevStep" class="pe-element-badge-pager-prev"></span><span data-ixp-flow-action="nextStep" class="pe-element-badge-pager-next"></span></div>',
            progressBar: '<div class="ixp-component-flow-progress ixp-component-flow-progress-%%style%%" data-ixp-progress-bar="%%ID%%"><ul class="ixp-component-flow-progress-inner"></ul></div>',
            progressItem: '<li class="ixp-component-flow-progress-toggle" tabindex="0" data-ixp-action-toggle="%%ID%%" data-step="%%iter%%" %%TOOLTIP%%>%%label%%</li>',
            nextButton: '<div role="button" tabindex="0" aria-label="next step" class="ixp-component-flow-control-next" data-ixp-action-next="%%ID%%"></div>',
            previousButton: '<div role="button" tabindex="0" aria-label="previous step" class="ixp-component-flow-control-back" data-ixp-action-previous="%%ID%%"></div>'
        },

        regex: {
            style: new RegExp('%%style%%', 'g'),
            id: new RegExp('%%ID%%', 'g'),
            iter: new RegExp('%%iter%%', 'g'),
            label: new RegExp('%%label%%', 'g'),
            tooltip: new RegExp('%%TOOLTIP%%', 'g')
        },

        behaviors: {
            nextStep: 'flow-next',
            previousStep: 'flow-back',
            firstStep: 'flow-first',
            lastStep: 'flow-last',
            convert: 'flow-convert',
            transitions: {
                allSteps: {
                    classSlideVertical: 'ixp-component-flow-vertical-all',
                    classSlideHorizontal: 'ixp-component-flow-horizontal-all',
                    classFade: 'ixp-component-flow-fade-all',
                    allClasses: 'ixp-component-flow-vertical-all ixp-component-flow-horizontal-all ixp-component-flow-fade-all'
                },
                step: {
                    classSlideVertical: 'ixp-component-flow-vertical',
                    classSlideHorizontal: 'ixp-component-flow-horizontal',
                    classFade: 'ixp-component-flow-fade',
                    allClasses: 'ixp-component-flow-vertical ixp-component-flow-horizontal ixp-component-flow-fade'
                },
                duration: 500,
                easing: 'linear'
            }
        },

        step: {
            events: {
                resized: ':flowstep:resize'
            }
        },

        extensibility: {
            commands: {
                navigate: ':navigate',
                scrollto: ':scrollto'
            },

            events: {
                navigating: ':navigating',
                navigated: ':navigated'
            }
        }
    });

    runtime.components.registerExtensibility('ixp-flow', {
        commands: constants.extensibility.commands || {},
        events: constants.extensibility.events || {}
    });

    var statics = {
        updateProgress: function(style, stepCount, instanceId, $el) {
            var getProgressBar = function() {
                return $el.children('[data-ixp-progress-bar]');
            };

            var progressBar = getProgressBar();
            if (stepCount < 1 || style === 'none') {
                if (progressBar.length) {
                    progressBar.remove();
                }
                return;
            }

            $el.removeClass('ixp-component-flow-progress-off');
            $el.addClass('ixp-component-flow-progress-on');

            if (progressBar.length) {
                progressBar.children().children().remove();
            } else {
                var progressTmpl = constants.templates.progressBar;
                progressTmpl = progressTmpl.replace(constants.regex.style, style);
                progressTmpl = progressTmpl.replace(constants.regex.id, instanceId);
                $el.append(progressTmpl);
                progressBar = getProgressBar();
            }

            var $steps = $el.children('.ixp-component-flow-steps').children();

            var progressItems = [];
            for (var i = 0; i < stepCount; i++) {
                var $step = $steps.eq(i);
                var tooltip = $step && $step.attr('data-ixp-component-flow-step-tooltip') || '';
                if (tooltip !== '') {
                    tooltip = 'data-ixp-c-flow-tooltip="' + tooltip + '"';
                }

                var itemTmpl = constants.templates.progressItem;
                itemTmpl = itemTmpl.replace(constants.regex.iter, i);
                itemTmpl = itemTmpl.replace(constants.regex.label, i + 1);
                itemTmpl = itemTmpl.replace(constants.regex.id, instanceId);
                itemTmpl = itemTmpl.replace(constants.regex.tooltip, tooltip);
                progressItems.push(itemTmpl);
            }
            progressBar.children().first().html(progressItems.join(''));

            if (style === 'clickable') {
                progressBar.addClass(constants.progress.clickable);
            } else {
                progressBar.removeClass(constants.progress.clickable);
            }

            progressBar.addClass(constants.progress.progressInit);
        },

        updateControls: function(stepCount, instanceId, $el) {
            if (!stepCount) {
                $el.children('.ixp-component-flow-control-back, .ixp-component-flow-control-next').remove();
                return;
            }

            if ($el.children('.ixp-component-flow-control-back, .ixp-component-flow-control-next').length) {
                return;
            }

            var controlTmpl = '';

            var itemTmpl = constants.templates.previousButton;
            itemTmpl = itemTmpl.replace(constants.regex.id, instanceId);
            controlTmpl += itemTmpl;

            itemTmpl = constants.templates.nextButton;
            itemTmpl = itemTmpl.replace(constants.regex.id, instanceId);
            controlTmpl += itemTmpl;

            $el.append(controlTmpl);
        },

        getFlowScaffolding: function(scaffoldingKey, builder, options) {
            var container = builder.scaffoldContainer('Flow');

            var steps = [];
            for (var i = 1; i < 4; i++) {
                var step = builder.scaffold('ixp-flow-step', 'Flow Step');
                steps.push(step);
            }

            container.content.scaffolding = steps;

            return {
                scaffolding: [ container ],
                style: {
                    customClass: builder.getDefaultThemes({
                                                              'flow': '',
                                                              'flow-progress': 'ixp-component-flow-default',
                                                              'flow-progress-align-horizontal': '',
                                                              'flow-progress-align-vertical': '',
                                                              'flow-transition': ''
                                                          })
                }
            };
        },

        getStepScaffolding: function(scaffoldingKey, builder, options) {
            var container = builder.scaffoldContainer('Flow Step');

            return {
                scaffolding: [ container ],
                style: {
                    customClass: builder.getDefaultThemes({ 'flowstep': '', 'flowstep-transition': '' })
                }
            };
        }
    };

    runtime.components.register('ixp-flow', {
        initialize: function(options) {
            this.transitionEndEventName = 'webkitTransitionEnd' + this.eventNamespace + ' otransitionend' + this.eventNamespace + ' msTransitionEnd' + this.eventNamespace + ' transitionend' + this.eventNamespace;
            this.progressSelector = '[data-ixp-action-toggle="' + this.instanceId + '"]';
            this.previousSelector = '[data-ixp-action-previous="' + this.instanceId + '"]';
            this.nextSelector = '[data-ixp-action-next="' + this.instanceId + '"]';
            this.stepDelegateSelector = '[data-ixp-flow-steps="' + this.instanceId + '"] > .ixp-component-flow-step';
            this.seq = 0;

            if (this.looping_enabled) {
                this.$el.removeClass('ixp-component-flow-no-looping');
            }

            this._updateSteps();
            this._updateControls();
            this._updateProgress();

            this.debouncedCleanSteps = _.debounce(_.bind(this._cleanSteps, this), 50, { maxWait: 100 });
            this.$el.on(this.transitionEndEventName, this.stepDelegateSelector, _.bind(this._onTransitionEnd, this));

            this.activeHeight = this.inStudio ? this.stepsWrap.outerHeight() : 0;

            this.show({
                step: this.seq
            });

            this.debouncedShow = _.debounce(this.show, 250, { 'leading': true, 'trailing': false });

            runtime.events.on(this, this.instanceId + constants.step.events.resized, _.debounce(_.bind(this._onResize, this), 10, { maxWait: 20 }));

            if (!this.inStudio) {
                this.onBehavior(this.$el, constants.behaviors.nextStep, this._onBehaviorGotoNext);
                this.onBehavior(this.$el, constants.behaviors.previousStep, this._onBehaviorGotoPrevious);
                this.onBehavior(this.$el, constants.behaviors.firstStep, this._onBehaviorGotoFirst);
                this.onBehavior(this.$el, constants.behaviors.lastStep, this._onBehaviorGotoLast);
            }
        },

        onDocumentReady: function() {
            this._onResize();
            this.recalculateVisibility({ delay: 1 });
            if (!this.inStudio) {
                if (canTouchThis && this.navigation_enabled) {
                    var me = this;
                    hammerTime(function(Hammer) {
                        if (!me.hammerInstance) {
                            var $swipeTarget = me.$el.find('[data-ixp-flow-steps="' + me.instanceId + '"]');
                            me.hammerInstance = new Hammer($swipeTarget[0]);
                        }

                        me.hammerInstance.off('swipe');
                        me.hammerInstance.on('swipe', function(e) {
                            e.preventDefault();

                            var options = {
                                isClicked: true,
                                loop: me.looping_enabled,
                                interaction: {
                                    source: 'swipe',
                                    direction: e.direction
                                }
                            };
                            if (e.direction === Hammer.DIRECTION_RIGHT || e.direction === Hammer.DIRECTION_DOWN) {
                                me.previous(options);
                            } else {
                                me.next(options);
                            }
                        });
                    });
                }
                if (this.autoplay_enabled) {
                    this.startAuto();
                }
            }
            return true;
        },
        stopAuto: function() {
            if (this.autoTimer) {
                clearInterval(this.autoTimer);
                delete this.autoTimer;
            }
        },
        startAuto: function() {
            this.stopAuto();

            if (this.inStudio) {
                return;
            }

            if (!this.autoPlayDuration) {
                var dur = 4000;
                if (this.autoplay_delay) {
                    var newDur = parseInt(this.autoplay_delay, 10);
                    if (!isNaN(newDur)) {
                        dur = Math.abs(newDur * 1000);
                    }
                }
                this.autoPlayDuration = dur;
            }
            var me = this;
            this.autoTimer = setInterval(function() {
                me.next({ loop: me.looping_enabled }); // Do not pass interaction object here, means auto_play is not user interaction
            }, this.autoPlayDuration);
        },

        // public methods
        show: function(options) {
            options = _.extend({
                                   step: 0,
                                   stepCount: this.maxseq
                               }, options || {});

            if (options.isClicked && options.isClicked === true) {
                if (this.autoplay_enabled && !this.autoplay_stop_on_navigation) {
                    this.autoplayPaused = true;
                }
                this.stopAuto();
            }

            var currSeq = this.seq;
            var maxStep = options.stepCount;
            var targetSeq = options.step;

            var isLooping = false;
            if (targetSeq >= maxStep) {
                if (options.loop === true) {
                    targetSeq = 0;
                    isLooping = true;
                } else {
                    targetSeq = maxStep - 1;
                }
            } else if (targetSeq < 0) {
                if (options.loop === true) {
                    targetSeq = maxStep - 1;
                    isLooping = true;
                } else {
                    targetSeq = 0;
                }
            }

            if (!options.force && this.showInit && currSeq === targetSeq) {
                return;
            }

            var steps = this._getSteps();
            var currStep = steps.filter(':eq(' + currSeq + ')');
            var targetStep = steps.filter(':eq(' + targetSeq + ')');

            var ee = {
                steps: maxStep,
                step: { index: currSeq, element: currStep[0] },
                targetStep: { index: targetSeq, element: targetStep[0] },
                cancel: false
            };
            this.triggerExtensibility(constants.extensibility.events.navigating, ee);

            targetSeq = ee.targetStep && ee.targetStep.index;
            if (ee.cancel || targetSeq >= maxStep || targetSeq < 0 ||
                (!options.force && this.showInit && targetSeq === currSeq)) {
                return;
            }

            var isForward = false;
            if (!this.showInit || (isLooping & targetSeq === 0) || (!isLooping && targetSeq > currSeq)) {
                isForward = true;
            }

            var direction = isForward ? 'forward' : 'backward';
            var progress = targetSeq === 0 ? 'start' : targetSeq === (maxStep - 1) ? 'end' : 'middle';

            //console.log('current: ' + currSeq);
            //console.log('target:  ' + targetSeq);

            // TOGGLE PROGRESS SEQ
            var progressItems = this.$el.find(this.progressSelector);
            var targetProgressItem = progressItems.filter(':eq(' + targetSeq + ')');

            progressItems.removeClass(constants.progress.activeStep + ' ' + constants.progress.doneStep);
            targetProgressItem.prevAll().addClass(constants.progress.doneStep);
            targetProgressItem.addClass(constants.progress.activeStep);

            /**
             *
             * data-ixp-flow-direction = forward || backward
             * data-ixp-flow-step-transitioning = leave || enter
             * [data-ixp-flow-step-transitioning]
             * removeAttr('data-ixp-flow-step-transitioning')
             * data-ixp-flow-step-placement = in || out
             *
             *
             */
            this.$el.attr('data-ixp-flow-direction', direction);
            this.$el.attr('data-ixp-flow-progress', progress);

            var me = this;

            if (Modernizr && Modernizr.csstransitions !== true) {
                if (this.showInit) {
                    // Use JS animations - slide, fade, etc
                    currStep.attr(constants.steps.attrTransitioning, 'leave');
                    targetStep.attr(constants.steps.attrTransitioning, 'enter');
                    this.activeStep = targetStep;
                    this._doTransitions(isForward, targetStep, currStep);
                } else {
                    targetStep.siblings().attr(constants.steps.attrPlacement, 'out').hide();
                    targetStep
                        .attr(constants.steps.attrPlacement, 'in')
                        .css({
                            left: 0,
                            top: 0
                        })
                        .show();
                    this.activeStep = targetStep;
                }
            } else {
                if (this.showInit) {
                    setTimeout(function() {
                        currStep.attr(constants.steps.attrTransitioning, 'leave');
                        targetStep.attr(constants.steps.attrTransitioning, 'enter');
                        me.activeStep = targetStep;

                        if (me.$el.is(':hidden')) {
                            setTimeout(function() {
                                me._cleanSteps();
                            }, 1);
                        }
                    }, 1);
                } else {
                    targetStep.siblings().attr(constants.steps.attrPlacement, 'out');
                    targetStep.attr(constants.steps.attrPlacement, 'in');
                    this.activeStep = targetStep;
                }
            }

            this.seq = targetSeq;
            this._onResize();

            if (options.isClicked && options.isClicked === true) {
                if (window.liveballTag) {
                    var $data = targetStep.data('ixp-component-tag');
                    if ($data !== '') {
                        liveballTag($data);
                    }
                }
            }

            if (!this.showInit) {
                this.$el.removeClass(constants.initClass);
                this.showInit = true;
            }

            // Push step moved interaction here
            if (options.interaction) {
                this.pushInteraction(_.assign({
                    name: 'step moved',
                    step: this.seq
                }, options.interaction));
            }

            // Mark user as converted when opened defined slide
            if (!this.inStudio && targetStep.find('[data-ixp-behavior-'+ constants.behaviors.convert +']').length) {
                runtime.convert();
            }
        },

        _getTransition: function($step) {
            var getStyle = function($target, stepClasses) {
                if ($target.hasClass(stepClasses.classSlideVertical)) {
                    return 'slideY';
                } else if ($target.hasClass(stepClasses.classSlideHorizontal)) {
                    return 'slideX';
                } else if ($target.hasClass(stepClasses.classFade)) {
                    return 'fade';
                }
                return null;
            };

            var stepStyle = getStyle($step, constants.behaviors.transitions.step);
            if (!stepStyle) {
                var $parent = this.$el;
                stepStyle = getStyle($parent,constants.behaviors.transitions.allSteps);
            }
            return stepStyle;
        },

        _doTransitions: function(isForward, targetStep, currentStep) {
            var targetStyle = this._getTransition(targetStep);
            var currentStyle = this._getTransition(currentStep);
            if (targetStyle === 'slideX' || targetStyle === 'slideY') {
                var me = this;
                targetStep.show(0, function() {
                    me._doTransition(currentStep, currentStyle, isForward, false);
                    me._doTransition(targetStep, targetStyle, isForward, true);
                });
            } else {
                this._doTransition(currentStep, currentStyle, isForward, false);
                this._doTransition(targetStep, targetStyle, isForward, true);
            }
        },

        _doTransition: function($step, style, isForward, active) {
            if (!active && active !== false) {
                active = false;
            }
            var me = this;
            if (style === 'fade') {
                var opacity = active ? 1 : 0;
                $step.fadeTo(
                    constants.behaviors.transitions.duration,
                    opacity,
                    constants.behaviors.transitions.easing,
                    function() {
                        if (active) {
                            me._cleanSteps();
                        }
                    }
                );
            } else if (style === 'slideX' || style === 'slideY') {
                var prop, amount;
                if (style === 'slideX') {
                    prop = 'left';
                    amount = this.stepsWrap.outerWidth() + "px";
                } else {
                    prop = 'top';
                    amount = this.stepsWrap.outerHeight() + "px";
                }
                var movement = isForward ? '-=' : '+=';
                var animateOpts = {};
                animateOpts[prop] = movement + amount;

                $step.animate(animateOpts, {
                    duration: constants.behaviors.transitions.duration,
                    queue: false,
                    complete: function() {
                        if (active) {
                            me._cleanSteps();
                        }
                    }
                });
            } else {
                $step.toggle(active);
                if (active){
                    this._cleanSteps();
                }
            }
        },

        previous: function(options) {
            options = _.extend(options || {}, { step: this.seq - 1 });
            this.debouncedShow(options);
        },

        next: function(options) {
            options = _.extend(options || {}, { step: this.seq + 1 });
            this.debouncedShow(options);
        },

        // events
        _onResize: function (e) {
            if (!this.inStudio || this.activeHeight !== this._getActiveHeight()) {
                this._updateHeight();
            }
        },

        _onTransitionEnd: function(e) {
            if (this._isOwnStep($(e.target))) {
                this.debouncedCleanSteps();
            }
        },

        _cleanSteps: function() {
            var steps = this._getSteps();
            this.activeStep.attr(constants.steps.attrPlacement, 'in');
            steps.removeAttr(constants.steps.attrTransitioning);
            this.activeStep.siblings().attr(constants.steps.attrPlacement, 'out');

            var scrollTopAllowed = !this.inStudio && this.change_scroll_top;
            if (scrollTopAllowed && (this.scrollToDeferred && this.scrollToDeferred.preventScrollToStep)) {
                scrollTopAllowed = false;
            }
            if (scrollTopAllowed) {
                runtime.scrollTo(this.activeStep, {
                    speed: (constants.behaviors.transitions.duration / 2),
                    inViewport: {
                        tolerance: 1,
                        edge: 'top'
                    },
                    updateUrlHash: false
                });
            }

            this.recalculateVisibility({ delay: 1 });

            var ee = {
                steps: this.maxseq,
                step: { index: this.seq, element: steps.filter(':eq(' + this.seq + ')')[0] }
            };
            this.triggerExtensibility(constants.extensibility.events.navigated, ee);

            this._resolveScrollTo('completed');

            if (this.autoplayPaused) {
                this.autoplayPaused = false;
                this.startAuto();
            }
        },

        _onProgressClick: function(e) {
            e.preventDefault();

            var target = e.target;

            this.show({
                step: this.$(target).data('step'),
                isClicked: true,
                interaction: {
                    source: 'click',
                    sourceTarget: 'progress'
                }
            });
        },

        _onFocusClick: function(event) {
            if (event.keyCode == 13 || event.keyCode == 32) {
                event.preventDefault();
                var target = event.target;

                this.show({
                    step: this.$(target).data('step'),
                    isClicked: true,
                    interaction: {
                        source: 'keyup',
                        sourceTarget: 'progress'
                    }
                });
            }
        },

        _onClickGotoNext: function(e) {
            e.preventDefault();

            this.next({
                isClicked: true,
                loop: this.looping_enabled,
                interaction: {
                    source: 'click',
                    sourceTarget: 'next'
                }
            });
        },

        _onClickGotoPrevious: function (e) {
            e.preventDefault();

            this.previous({
                isClicked: true,
                loop: this.looping_enabled,
                interaction: {
                    source: 'click',
                    sourceTarget: 'previous'
                }
            });
        },

        _onFocusClickGotoNext: function(event) {
            if (event.keyCode == 13 || event.keyCode == 32) {
                event.preventDefault();

                this.next({
                    isClicked: true,
                    loop: this.looping_enabled,
                    interaction: {
                        source: 'keyboard',
                        sourceTarget: 'next'
                    }
                });
            }
        },

        _onFocusClickGotoPrevious: function (event) {
            if (event.keyCode == 13 || event.keyCode == 32) {
                event.preventDefault();

                this.previous({
                    isClicked: true,
                    loop: this.looping_enabled,
                    interaction: {
                        source: 'keyboard',
                        sourceTarget: 'previous'
                    }
                });
            }
        },

        _onBehaviorGotoNext: function(e) {
            e.preventDefault();

            var max = this.maxseq;
            var curr = this.seq;

            if (curr < max) {
                if (e.originalEvent && e.originalEvent[constants.inputs.events.handled + this.instanceId]) {
                    return;
                }
                e.originalEvent[constants.inputs.events.handled + this.instanceId] = true;

                this.next({
                    isClicked: true,
                    interaction: {
                        source: 'behavior',
                        behaviourName: constants.behaviors.nextStep
                    }
                });
            }
        },

        _onBehaviorGotoPrevious: function(e) {
            e.preventDefault();

            var curr = this.seq;
            if (curr > 0) {
                if (e.originalEvent && e.originalEvent[constants.inputs.events.handled + this.instanceId]) {
                    return;
                }
                e.originalEvent[constants.inputs.events.handled + this.instanceId] = true;

                this.previous({
                    isClicked: true,
                    interaction: {
                        source: 'behavior',
                        behaviourName: constants.behaviors.previousStep
                    }
                });
            }
        },

        _onBehaviorGotoFirst: function(e) {
            e.preventDefault();

            if (e.originalEvent && e.originalEvent[constants.inputs.events.handled + this.instanceId]) {
                return;
            }
            e.originalEvent[constants.inputs.events.handled + this.instanceId] = true;

            this.show({
                step: 0,
                isClicked: true,
                interaction: {
                    source: 'behavior',
                    behaviourName: constants.behaviors.firstStep
                }
            });
        },

        _onBehaviorGotoLast: function(e) {
            e.preventDefault();

            if (e.originalEvent && e.originalEvent[constants.inputs.events.handled + this.instanceId]) {
                return;
            }
            e.originalEvent[constants.inputs.events.handled + this.instanceId] = true;

            this.show({
                step: this.maxseq,
                isClicked: true,
                interaction: {
                    source: 'behavior',
                    behaviourName: constants.behaviors.lastStep
                }
            });
        },

        // setup functions
        _getSteps: function() {
            return this.stepsWrap.children('.ixp-component-flow-step');
        },

        _updateSteps: function() {
            this.stepsWrap = this.$el.children('.ixp-component-flow-steps').first();
            var steps = this._getSteps();
            this.maxseq = steps.length;
        },
        _shouldShowProgress: function() {
            var className = this.$el.attr('class') || '';
            if (!className) {
                return false;
            } else if (className.indexOf('ixp-c-flow-style-brand-') > -1) {
                return true;
            } else {
                var classes = [
                    'ixp-component-flow-default',
                    'ixp-component-flow-dots-light-solid',
                    'ixp-component-flow-dots-light',
                    'ixp-component-flow-dots-dark-solid',
                    'ixp-component-flow-dots-dark',
                    'ixp-component-flow-bar-light',
                    'ixp-component-flow-bar-dark'
                ];

                for (var i= 0, len = classes.length; i < len; i++) {
                    if (this.$el.hasClass(classes[i])) {
                        return true;
                    }
                }
            }

            return false;
        },

        _updateProgress: function() {
            var isClickable = this.inEditMode ? false : this.navigation_enabled;

            var style = 'none';
            if (this._shouldShowProgress()) {
                style = isClickable ? 'clickable' : 'display';
            }

            var clickEventName = 'click' + this.eventNamespace;
            var keyUpEventName = 'keyup' + this.eventNamespace;
            this.$el.off(clickEventName, this.progressSelector);
            this.$el.off(keyUpEventName, this.progressSelector);

            statics.updateProgress(style, this.maxseq, this.instanceId, this.$el);

            if (isClickable) {
                this.$el.on(clickEventName, this.progressSelector, _.bind(this._onProgressClick, this));
                this.$el.on(keyUpEventName, this.progressSelector, _.bind(this._onFocusClick, this));
            }
        },

        _updateControls: function() {
            var clickEventName = 'click' + this.eventNamespace;
            var keyUpEventName = 'keyup' + this.eventNamespace;
            var className = this.$el.attr('class') || '';
            if (this.inEditMode || !className || (className.indexOf('ixp-c-flow-style-brand-') === -1 && className.indexOf('ixp-component-flow-controls-') === -1)) {
                if (this.inStudio) {
                    this.$el.off(clickEventName, this.previousSelector);
                    this.$el.off(clickEventName, this.nextSelector);
                    statics.updateControls(0, this.instanceId, this.$el);
                }
                return;
            }

            this.$el.off(clickEventName, this.previousSelector);
            this.$el.off(clickEventName, this.nextSelector);
            this.$el.off(keyUpEventName, this.previousSelector);
            this.$el.off(keyUpEventName, this.nextSelector);

            statics.updateControls(this.maxseq, this.instanceId, this.$el);

            this.$el.on(clickEventName, this.previousSelector, _.bind(this._onClickGotoPrevious, this));
            this.$el.on(clickEventName, this.nextSelector, _.bind(this._onClickGotoNext, this));
            this.$el.on(keyUpEventName, this.previousSelector, _.bind(this._onFocusClickGotoPrevious, this));
            this.$el.on(keyUpEventName, this.nextSelector, _.bind(this._onFocusClickGotoNext, this));
        },

        _updateHeight: function() {
            var $body = this.$('body');
            var scrollTop = $body.scrollTop();

            var newHeight = this._getActiveHeight();

            if (!this.inEditMode) {
                this.stepsWrap.css('height', newHeight + 'px');
                $body.scrollTop(scrollTop);
            } else {
                this.stepsWrap.css('height', 'auto');
            }

            if (this.activeHeight !== newHeight) {
                // Keep track of the current flow step's height.
                this.activeHeight = newHeight;

                if (this.inStudio && this.studioApp) {
                    this.studioApp.componentsManager.trigger('rmw:reflowed', {instanceId: this.instanceId});
                }
            }
        },

        _getActiveHeight: function () {
            var newHeight = 0;

            var steps = this._getSteps(),
                maxStep = steps.length - 1;

            // Adjust current step, if necessary.
            if (this.seq > maxStep) {
                this.seq = maxStep;
            } else if (this.seq < 0) {
                this.seq = 0;
            }

            if (this.fixed_height) {
                var me = this;
                steps.each(function () {
                    var height = me.$(this).outerHeight();
                    if (height > newHeight) {
                        newHeight = height;
                    }
                });
            } else {
                if (this.seq >= 0 && this.seq < steps.length) {
                    newHeight = this.$(steps[this.seq]).outerHeight();
                }
            }

            if (newHeight === 0 && (this.activeHeight && this.activeHeight > 0)) {
                newHeight = this.activeHeight;
            }

            return newHeight;
        },

        _createElementBadgeUi: function($div) {
            this.elementBadgeUi = $div.append(constants.templates.badgeUi).toggle(!this.inEditMode);
            var me = this;
            $div.find('[data-ixp-flow-action="nextStep"]').on('click', function(e) {
                me._onBehaviorGotoNext(e);
            });
            $div.find('[data-ixp-flow-action="prevStep"]').on('click', function(e) {
                me._onBehaviorGotoPrevious(e);
            });
        },

        _toggleElementBadgeUi: function(show) {
            if (!this.elementBadgeUi) {
                return;
            }
            this.elementBadgeUi.toggle(show);
        },

        // creative studio functions
        allowedDropTargets: function () {
            return ['Container', 'Column'];
        },

        allowedChildrenTypes: function() {
            return ['ixp-flow-step'];
        },

        onGetCommandMap: function() {
            var commands = {};
            commands[constants.extensibility.commands.navigate] = {
                fn: this._onCommandNavigate
            };
            commands[constants.extensibility.commands.scrollto] = {
                fn: this._onCommandScrollTo
            };
            return commands;
        },

        _isOwnStep: function($el) {
            if (!$el.is('.ixp-component-flow-step')) {
                return false;
            }
            var $stepsContainer = $el.closest('.ixp-component-flow-steps');
            var stepOwnerId = $stepsContainer.attr('data-ixp-flow-steps');
            return stepOwnerId === this.instanceId;
        },

        _getOwnStepFromElement: function($el) {
            if (this._isOwnStep($el)) {
                return $el;
            }

            var $nextStep = $el.parent().closest('.ixp-component-flow-step');
            if (!$nextStep.length) {
                return;
            }

            return this._getOwnStepFromElement($nextStep);
        },

        _onCommandScrollTo: function(e) {
            runtime.log('_onCommandScrollTo called on', this, e);

            if (!e) {
                return;
            }

            this._resolveScrollTo('aborted');

            var step, $step;
            var targetIsStep = true;
            if (e.element || e.anchor) {
                var $descendantTarget;
                if (e.element) {
                    $descendantTarget = this.$el.find(e.element);
                } else {
                    $descendantTarget = this.$el.find('[data-ixp-anchor="' + e.anchor + '"]');
                }
                if ($descendantTarget.length) {
                    $step = $descendantTarget;
                    if (!this._isOwnStep($descendantTarget)) {
                        targetIsStep = false;
                        $step = this._getOwnStepFromElement($descendantTarget);
                    }

                    if (!$step || !$step.length) {
                        return;
                    }

                    //step = $step.index();
                    step = this.$.inArray($step.attr('id'), $step.parent().children('.ixp-component-flow-step').map(function() { return this.id }));
                }
            } else if (e.step) {
                step = e.step;
            } else {
                return;
            }

            this.scrollToDeferred = {
                preventScrollToStep: true
            };

            var me = this;
            var promise = new Promise(function (resolve, reject) {
                me.scrollToDeferred.resolve = resolve;
                me.scrollToDeferred.reject = reject;
            });

            var ee = {
                step: step,
                status: 'pending',
                promise: promise,
                preventDefault: false
            };

            if (targetIsStep) {
                ee.element = this.$el[0];
                if (this.change_scroll_top) {
                    ee.inViewport = {
                        tolerance: 1,
                        edge: 'top'
                    };
                } else {
                    ee.inViewport = { tolerance: 0.5 };
                }
            }

            this.scrollToDeferred.envelope = this.getExtensibilityEnvelope(ee);

            if (this.seq === step) {
                this._resolveScrollTo('completed');
            }

            this.show({ step: step });
            this.triggerExtensibility(null, ee, { done: e.done });
        },

        _resolveScrollTo: function(status) {
            if (this.scrollToDeferred) {
                this.scrollToDeferred.envelope.status = status;
                this.scrollToDeferred.resolve(this.scrollToDeferred.envelope);
                this.scrollToDeferred = undefined;
            }
        },

        _onCommandNavigate: function(e) {
            this.show({ step: e.step });
        },

        getParamMapOverrides: function() {
            return {
                fixed_height: function(val) {
                    this.fixed_height = val === "true";
                    this._onResize();
                },
                looping_enabled: function(val) {
                    this.looping_enabled = val;
                    this.$el.removeClass('ixp-component-flow-no-looping', !this.looping_enabled);
                }
            }
        },

        onGetScaffolding: function(scaffoldingKey, builder, options) {
            return statics.getFlowScaffolding(scaffoldingKey, builder, options);
        },

        onGetCssClassesToPreserve: function() {
            return [ '!'+ constants.initClass ];
        },

        onStudioStateChanged: function() {
            var state = this.studioApp.state;
            if (state.pagePlaceholders === 'hidden') {
                this.$el.attr(constants.modes.modeAttr, constants.modes.normalMode);
                if (this.inEditMode) {
                    this.inEditMode = false;
                    this._updateHeight();
                    this._updateControls();
                    this._toggleElementBadgeUi(true);
                }
            } else {
                this.$el.attr(constants.modes.modeAttr, constants.modes.editMode);
                if (!this.inEditMode) {
                    this.inEditMode = true;
                    this._updateHeight();
                    this._updateControls();
                    this._toggleElementBadgeUi(false);
                }
            }
        },

        onListenToStudioEvents: function(events) {
            this.onStudioStateChanged();
            events.on('page:reflowed', function(e) {
                if (e && e.source && e.source.id === this.instanceId && e.source.element) {
                    if (e.source.element && this.$(e.source.element).hasClass(constants.initClass)) {
                        this.showInit = false;
                    }
                }
                if (!e || e.instanceId !== this.instanceId) {
                    this._updateSteps();
                    this._updateProgress();
                    this._updateControls();
                    this.show({
                        step: this.seq,
                        force: true
                    });
                }
            }, this);
            events.on('element:badge:activated', function(e) {
               if (e.instanceId === this.instanceId) {
                   this._createElementBadgeUi(e.$badgeExtensibility);
               }
            }, this);
        }
    });


    runtime.components.register('ixp-flow-step', {
        initialize: function(options) {
            var $flow = this.$el.closest(constants.flowSelector);
            this.flowInstanceId = $flow.attr(constants.components.data.componentRoot);
        },

        onDocumentReady: function() {
            this.$el.on('resize' + this.eventNamespace, _.bind(this._onResize, this));
            return true;
        },

        _onResize: function() {
            runtime.events.trigger(this.flowInstanceId + constants.step.events.resized, { instanceId: this.instanceId });
        },

        getParamMapOverrides: function() {
            return {
                step_tag: function(val) {
                    if (val) {
                        this.$el.attr('data-ixp-component-tag', val);
                    }
                },
                step_navigation_tooltip: function(val) {
                    if (val) {
                        this.$el.attr('data-ixp-component-flow-step-tooltip', val);
                    }
                }
            }
        },

        disallowedChildrenTypes: function() {
            return ['ixp-flow-step'];
        },

        allowedDropTargets: function () {
            return ['ixp-flow'];
        },

        onGetScaffolding: function(scaffoldingKey, builder, options) {
            return statics.getStepScaffolding(scaffoldingKey, builder, options);
        }
    });
})(window.ixp.runtime);
